import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable, catchError, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  pagination = localStorage.getItem('pagination') ? JSON.parse(localStorage.getItem('pagination') as string) : JSON.parse('{"page":0,"size":5,"totalElements":0,"totalPages":0}');

  dataUrl = '../../../assets/data';

  //  =============== Dependency injection ===============

  private orderBy: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  orderBy$: Observable<any> = this.orderBy.asObservable();

  private readonly _actRoute = inject(ActivatedRoute);
  private readonly _router = inject(Router);
  private readonly _http = inject(HttpClient);

  constructor() {}

  setOrderBy(orderBy: any): void {
    this.orderBy.next(orderBy);
  }
  // getOrderBy(): any { return this.orderBy.getValue();}

  // =============== Endpoints ===============

  getAllCountries(): Observable<any> {
    const url = `${this.dataUrl}/list-countries.json`;
    // const url = 'https://restcountries.com/v3.1/all';
    return this._http.get<any>(url).pipe(
      tap((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        throw err;
      }),
    );
  }

  extractRouteInfo(): any {
    const url = this._router.url;
    const urlArray = url.split('/');
    const urlArrayLength = urlArray.length;
    const path = urlArray[urlArrayLength - 1];
    const breadcrumbs = `${urlArray[urlArrayLength - 2]}/${urlArray[urlArrayLength - 1]}`;

    return {
      url,
      urlArray,
      urlArrayLength,
      path,
      breadcrumbs,
      pagination: this.pagination,
    };
  }

  // flattenObject(obj: any) {

  //     const result: { [key: string]: any } = {};

  //     const addEntries = (cur: any, prop: any) => {
  //         if (Object(cur) !== cur || Array.isArray(cur)) {
  //             result[prop] = cur;
  //         } else {
  //             Object.entries(cur).forEach(([key, value]) => {
  //                 addEntries(value, prop ? `${prop}.${key}` : key);
  //             });
  //         }
  //     };

  //     addEntries(obj, '');
  //     return result;
  // }

  // getFlatPagination() {
  //   return this.flattenObject(this.pagination);
  // }

  /**
   * 
   * @param obj 
   * @returns 

   * Metodo para recorrer un objeto y eliminar los espacios en blanco de las propiedades de tipo string
   */
  public trimStringProperties(obj: any): any {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      acc[key] = typeof value === 'string' ? value.trim() : value;
      return acc;
    }, {} as any);
  }

  /**
   * Convierte los campos vacíos ('', "") de un objeto en null.
   * @param data - El objeto que contiene los datos del formulario.
   * @returns Un nuevo objeto con los campos vacíos convertidos en null.
   */
  public convertEmptyToNull<T extends Record<string, any>>(data: T): T {
    return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, value === '' || value === '' ? null : value])) as T;
  }

  /**
   * Convierte los valores `null` null, "-" "_" en un "".
   * @param data - Objeto o arreglo a procesar.
   * @return Un nuevo objeto o arreglo con los valores `null` convertidos en `""`.
   */

  public convertNullToEmptyString<T>(data: T): T {
    if (data === null || data === 'null' || data === '-') return '' as T;

    if (Array.isArray(data)) {
      return data.map((item) => this.convertNullToEmptyString(item)) as T;
    }

    if (typeof data === 'object' && data !== null) {
      return Object.fromEntries(
        Object.entries(data).map(([key, value]) => [key, value === null || value === 'null' || value === '-' || value === '_' ? '' : this.convertNullToEmptyString(value)]),
      ) as T;
    }

    return data;
  }

  /**
   * Convierte los valores `""` en `null`.
   * @param data - Objeto o arreglo a procesar.
   * @return Un nuevo objeto o arreglo con los valores `""` convertidos en `null`.
   */
  public convertEmptyStringToNull<T>(data: T): T {
    if (data === '') return null as T;

    if (Array.isArray(data)) {
      return data.map((item) => this.convertEmptyStringToNull(item)) as T;
    }

    if (typeof data === 'object' && data !== null) {
      return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, value === '' ? null : this.convertEmptyStringToNull(value)])) as T;
    }

    return data;
  }
}
